import React, { useEffect, useState } from 'react';
import Login from './Login.jsx';
import Register from './Register.jsx';
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { removeCookies } from '../../services/Cookies.jsx';
import { setloggedIn } from '../../store/Slices/userSlice.js';
import { useResponsive } from '../../hooks/useResponsive.js';
import Tagline from './Tagline.jsx';

export default function AuthComponent() {

    const { isMobile } = useResponsive();
    const [searchParams] = useSearchParams();
    const [activeTab, setActiveTab] = useState('login');
    const dispatch = useDispatch();
    useEffect(() => {
        const tab = (searchParams?.get('tab'))?.trim();
        if (tab) {
            if ((tab != 'login' && tab != 'register') || tab == 'undefined') {
                setActiveTab('login');
            }
            setActiveTab(tab);
        } else {
            setActiveTab('login');
        }
    }, [searchParams?.get('tab')]);

    useEffect(() => {
        dispatch(setloggedIn(false));
        removeCookies('token');
    }, [])


    return (
        <>
            {!isMobile ? <div className="flex items-center justify-center min-h-screen bg-[#f9f9f9] auth-bg">
                <Tagline />
                <div className={`w-full bg-white rounded-2xl shadow-xl ${activeTab === "register" ? 'max-w-xl px-10 py-5' : 'max-w-md p-10'}`}>
                    <div className={`flex justify-center ${activeTab === "register" ? 'mb-2' : 'mb-8'}`}>
                        <img src='/assets/logo/logo.png' alt='logo' className={`${activeTab === "register" ? 'h-12' : 'h-20 w-48'} object-contain`} />
                    </div>
                    <div className={activeTab === "register" ? "mt-1" : "mt-4"}>
                        {activeTab === 'login' ? <Login /> : <Register />}
                    </div>
                </div>
            </div>
                :
                <div className='min-h-screen bg-blue-50 mobile-dashboard'>
                    <div className='p-5 pt-10'>
                        <div className="flex justify-center mb-8">
                            <img src='/assets/logo/logo.png' alt='logo' className='h-16 w-44 object-contain ' />
                        </div>
                        {activeTab === 'login' ? <Login /> : <Register />}
                    </div>
                </div>
            }
        </>
    )
}